import { PureComponent, ReactNode } from 'react';
import { colorObject } from './Utils';

interface Props {
    content: string;
    type: string;
}

class Tag extends PureComponent<Props> {
    render(): ReactNode {
        const { content, type } = this.props;
        const { color, background } = colorObject[type] || colorObject['white'];

        return (
            <p
                className="whitespace-nowrap text-12 font-700 px-8 py-4 rounded-4"
                style={{ color, background }}
            >
                {content}
            </p>
        );
    }
}

export default Tag;
